"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _helpers = require("../../common/helpers");
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["severity", "variant", "icon", "onClose", "children", "className"];
/* eslint-disable jsx-a11y/control-has-associated-label */
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var classes = (0, _classVarianceAuthority.cva)(['relative', 'flex', 'flex-row', 'justify-center', 'gap-2', 'rounded', 'px-5', 'py-3', '[&_p]:font-semibold', '[&_a]:font-bold', '[&_a]:hover:text-inherit', '[&_*]:text-sm'], {
  variants: {
    variant: {
      filled: [],
      outlined: ['border', 'text-gray-700']
    },
    severity: {
      "default": [],
      success: [],
      info: [],
      warning: [],
      error: []
    },
    close: {
      "true": ['pr-12'],
      "false": ['pr-5']
    }
  },
  compoundVariants: [{
    severity: 'default',
    variant: 'filled',
    className: ['bg-secondary-200', '[&_*]:text-gray-700']
  }, {
    severity: 'info',
    variant: 'filled',
    className: ['bg-primary-50', '[&_*]:text-gray-700']
  }, {
    severity: 'success',
    variant: 'filled',
    className: ['bg-success', '[&_*]:text-white']
  }, {
    severity: 'warning',
    variant: 'filled',
    className: ['bg-warning', '[&_*]:text-white']
  }, {
    severity: 'error',
    variant: 'filled',
    className: ['bg-danger', '[&_*]:text-white']
  }, {
    severity: 'default',
    variant: 'outlined',
    className: ['border-secondary-200', 'bg-white']
  }, {
    severity: 'info',
    variant: 'outlined',
    className: ['border-primary', 'bg-white']
  }, {
    severity: 'success',
    variant: 'outlined',
    className: ['border-success', 'bg-white']
  }, {
    severity: 'warning',
    variant: 'outlined',
    className: ['border-warning', 'bg-white']
  }, {
    severity: 'error',
    variant: 'outlined',
    className: ['border-danger', 'bg-white']
  }]
});
var iconClasses = (0, _classVarianceAuthority.cva)(['mt-1'], {
  variants: {
    variant: {
      filled: [],
      outlined: []
    },
    severity: {
      "default": [],
      success: [],
      info: [],
      warning: [],
      error: []
    }
  },
  compoundVariants: [{
    variant: 'filled',
    severity: ['default', 'info'],
    className: ['text-gray-700']
  }, {
    variant: 'filled',
    severity: ['success', 'warning', 'error'],
    className: ['text-white']
  }, {
    variant: 'outlined',
    severity: 'default',
    className: ['text-secondary-200']
  }, {
    variant: 'outlined',
    severity: 'info',
    className: ['text-primary']
  }, {
    variant: 'outlined',
    severity: 'success',
    className: ['text-success']
  }, {
    variant: 'outlined',
    severity: 'warning',
    className: ['text-warning']
  }, {
    variant: 'outlined',
    severity: 'error',
    className: ['text-danger']
  }]
});
var severityToIcon = {
  'default': 'circle-info',
  'info': 'circle-info',
  'success': 'circle-check',
  'warning': 'triangle-exclamation',
  'error': 'triangle-exclamation'
};

/**
 * Alert - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/feedback-alert) | [DSM](https://sharphealthcare.notion.site/Alert-0c6a27d517c845fba9fa06ff25c5e8c4)
 */
var Alert = exports.Alert = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$severity = _ref.severity,
    severity = _ref$severity === void 0 ? 'default' : _ref$severity,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'filled' : _ref$variant,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? false : _ref$icon,
    onClose = _ref.onClose,
    children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: (0, _helpers.cn)(classes({
      severity: severity,
      variant: variant,
      close: Boolean(onClose),
      className: className
    })),
    children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: icon === true ? severityToIcon[severity] : icon,
      className: iconClasses({
        severity: severity,
        variant: variant
      })
    }), children, onClose && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      className: "absolute px-5 py-3 top-0 right-0",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: "xmark",
        title: "Close"
      })
    })]
  }));
});